var _path, _g, _path2, _g2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLutLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 31,
    viewBox: "0 0 72 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 0,
    width: 23,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9336 0.000244141H71.3957V31H49.9336V0.000244141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7124 6.9876C57.2048 7.0109 57.5815 7.04311 57.9587 7.04396C60.2474 7.05031 62.5365 7.01217 64.824 7.0626C66.8182 7.10625 68.1411 8.4877 68.1407 10.4044C68.1403 12.1896 66.7576 13.6313 64.8519 13.6847C62.4946 13.7503 60.1342 13.7385 57.7756 13.7071C56.9645 13.6965 56.6577 13.9385 56.6976 14.7869C56.7649 16.2238 56.6772 17.6676 56.7276 19.1058C56.8065 21.3415 57.8603 23.0412 59.9236 23.904C61.8386 24.7049 63.7709 24.6189 65.502 23.2726C67.3021 21.8725 68.8276 21.7962 70.254 23.0289C71.6893 24.2693 71.8028 26.3872 70.4163 27.6814C66.5847 31.2587 62.1259 31.8181 57.3934 29.9629C52.9346 28.2153 50.348 24.7693 50.1141 20.0118C49.842 14.4754 49.9564 8.91866 49.9632 3.37082C49.9653 1.28127 51.326 0.00449105 53.338 0.000253474C55.2017 -0.0039841 56.6272 1.4351 56.7043 3.45854C56.7484 4.6065 56.7124 5.75785 56.7124 6.9876Z",
    fill: "#4523B2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_129_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.396484 0H21.9944V30.9343H0.396484V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_129_650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09654 24.2841C8.75597 24.2841 10.2641 24.2841 11.7719 24.2841C14.061 24.2841 16.3506 24.2722 18.6397 24.2887C20.5445 24.3023 21.9942 25.7566 21.9946 27.6152C21.995 29.4645 20.5364 30.918 18.6134 30.9239C13.7178 30.9383 8.8225 30.9366 3.92683 30.9252C1.84109 30.9201 0.427015 29.5149 0.408793 27.416C0.385486 24.7112 0.402437 22.0055 0.402437 19.3002C0.402437 14.0651 0.398199 8.83003 0.404979 3.59493C0.407522 1.3808 1.72244 -0.00531529 3.78572 -0.000230197C5.7545 0.0048549 7.08255 1.40114 7.08849 3.57205C7.10713 10.0369 7.09611 16.5017 7.09654 22.9662C7.09654 23.3764 7.09654 23.7861 7.09654 24.2841Z",
    fill: "#4523B2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6676 16.5881C23.6676 16.0618 23.6439 15.5342 23.6718 15.0092C23.7625 13.3256 25.1427 12.0187 26.764 12.0598C28.3565 12.1001 29.6027 13.3993 29.679 15.0728C29.7282 16.1555 29.6739 17.2648 29.8977 18.3128C30.4376 20.8422 32.7415 22.3038 35.4773 21.9897C37.8283 21.7202 39.5068 19.7739 39.5441 17.2682C39.5551 16.5313 39.5115 15.791 39.5683 15.0583C39.695 13.426 40.9599 12.1281 42.4316 12.0607C44.0169 11.9882 45.4598 13.1129 45.631 14.8003C46.1268 19.6849 44.5813 24.3742 39.6912 26.8113C31.647 30.8204 23.6545 24.8077 23.6621 17.2199C23.6621 17.0093 23.6621 16.7987 23.6621 16.5881C23.6638 16.5881 23.6659 16.5881 23.6676 16.5881Z",
    fill: "#4523B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.49 5.98458C33.4816 7.74359 32.1001 9.08987 30.322 9.0725C28.6427 9.05597 27.2769 7.66901 27.2638 5.9672C27.251 4.3226 28.6893 2.86445 30.339 2.84877C32.0645 2.83266 33.4985 4.25946 33.49 5.98458Z",
    fill: "#4523B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1631 5.9242C42.1729 7.69466 40.8198 9.06424 39.0536 9.07272C37.334 9.08077 35.9169 7.65017 35.9318 5.92081C35.9457 4.28765 37.4293 2.82992 39.0587 2.84857C40.752 2.86763 42.1542 4.25671 42.1631 5.9242Z",
    fill: "#4523B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLutLogo);
export default __webpack_public_path__ + "static/media/LutLogo.2677d3804f29276e05f5b1599f8c56cd.svg";
export { ForwardRef as ReactComponent };